import styled from 'styled-components'
import { Modal } from 'reactstrap'
import { device, colors } from 'Styled/variables'

const handleHeightOfPictures = (title: string) => {
  switch (title) {
    case 'New updates are here for you!':
      return '192.96px'
    case 'Language matching':
      return '177.06px'
    case 'Budget based schedule':
      return '183.5px'
    case 'Reach estimation':
      return '118.79px'
    case "Similar artist's genres":
      return '169.3px'
    case 'New look':
      return '200px'
    default:
      return '200px'
  }
}

const handleWidthOfPictures = (title: string) => {
  switch (title) {
    case 'New updates are here for you!':
      return '183.96px'
    case 'Language matching':
      return '295px'
    case 'Budget based schedule':
      return '280px'
    case 'Reach estimation':
      return '364px'
    case "Similar artist's genres":
      return '310px'
    case 'New look':
      return '228.58px'
    default:
      return '300px'
  }
}

export const CampaignsContainer = styled.div`
  width: 100%;
  max-width: 1630px;
  padding: 0;
  margin: 0 auto;
  @media ${device.mobileMin} {
    padding: 0px 24px 0px 30px;
  }
`
export const Card = styled.div`
  width: 100%;
  font-size: 14px;
  background-color: transparent;
  flex-direction: column;
  border-radius: 0.25rem;
`
export const ThankYouModalWrapper = styled.div`
  padding: 24px 24px 48px 24px;
`

export const CampaignsContainerPageSubHeader = styled.div`
  font-size: 18px;
  line-height: 27px;
  font-weight: 600;
  color: ${colors.mainText};
  margin-bottom: 22.5px;
  @media ${device.mobileMin} {
    margin-bottom: 30.5px;
  }
`

export const ThankYouModalHeader = styled.div`
  text-align: center;
  color: ${colors.mainText};
  font-size: 18px;
  font-weight: normal;
  margin-bottom: 16px;
  line-height: 27px;
  margin-left: 10px;
`
export const ThankYouModalHeaderFirst = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  color: ${colors.mainText};
  font-size: 18px;
  font-weight: normal;
  margin-bottom: 16px;
  line-height: 27px;
  margin-left: 10px;
  & img {
    width: 16px;
    height: 16px;
  }
`

export const ThankYouText = styled.div`
  text-align: left;
  margin-bottom: 40px;
  line-height: 21px;
`

export const ThankYouBtns = styled.div`
  margin: 0 auto;
  text-align: center;
`

export const WhatsNewOnSoundCampaignContainer = styled.div`
  padding: 16px 16px 32px 16px;
  background-color: white;
  margin: 0 16px 70px;

  .slick-list {
    margin: 0 -10px;
  }

  .slick-slide > div {
    padding: 0 10px;
  }
  .ant-carousel .slick-dots li {
    width: 8px;
    margin-right: 4px;
  }
  .ant-carousel .slick-dots li button {
    width: 8px;
    height: 8px;
    background: ${colors.green1Light};
    opacity: 1;
    border-radius: 10px;
  }
  .ant-carousel .slick-dots li.slick-active button {
    opacity: 1;
    background: ${colors.green};
    border-radius: 10px;
  }
  .ant-carousel .slick-dots-bottom {
    bottom: 37px;
  }
  .ant-tabs-top > .ant-tabs-nav .ant-tabs-nav-wrap::before {
    box-shadow: none !important;
  }
  .ant-tabs-top > .ant-tabs-nav .ant-tabs-nav-wrap::after {
    box-shadow: none !important;
  }
  @media ${device.mobileMin} {
    background-color: transparent;
    box-sizing: border-box;
    padding: 0 100px 40px 100px;
    margin: 20px 0 0;
  }
  .ant-tabs-tab {
    border: none;
  }
  .ant-tabs-top > .ant-tabs-nav .ant-tabs-nav-wrap::before {
    box-shadow: none !important;
  }
  .ant-tabs-top > .ant-tabs-nav .ant-tabs-nav-wrap::after {
    box-shadow: none !important;
  }
`

export const WhatsNewOnSoundCampaignInnerContainer = styled.div`
  padding: 16px;
  background-color: ${colors.white};
`

export const WhatsNewOnSoundCampaignBtns = styled.div`
  margin: 0 auto;
`

export const WhatsNewOnSoundCampaignTitle = styled.div`
  color: ${colors.mainText};
  font-weight: 600;
  font-size: 14px;
  line-height: 21px;
  margin-top: 14px;
  margin-bottom: 16px;
  text-align: start;
  @media ${device.mobileMin} {
    font-size: 18px;
    line-height: 27px;
    margin-bottom: 16px;
    margin-top: 0;
  }
`

export const WhatsNewOnSoundCampaignText = styled.div`
  text-align: left;
  color: ${colors.mainText};
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  margin-bottom: 80px;
  @media ${device.mobileMin} {
    font-size: 18px;
    line-height: 27px;
  }
`

export const WrapperForImgContainer = styled.div`
  height: 210px;
  display: flex;
  justify-content: center;
  align-items: center;
  @media ${device.mobileMin} {
    height: 238px;
  }
`

export const WrapperForImg = styled.div`
  height: ${({ title }) => title && handleHeightOfPictures(title)};
  width: ${({ title }) => title && handleWidthOfPictures(title)};
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto auto;

  & img {
    object-fit: cover;
    margin-bottom: auto;
    max-width: 100%;
    height: auto;
  }
`

export const MobileHeader = styled.div`
  color: ${colors.mainText};
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  padding: 16px 16px 26px 16px;
  font-size: 20px;
  @media ${device.mobileMin} {
    padding: 16px;
  }
`

export const ModalHeaderRelease = styled.div`
  font-size: 20px;
  font-weight: 600;
  line-height: 30px;
  max-width: 200px;
  text-align: left;
  @media ${device.mobileMin} {
    max-width: none;
  }
`

export const ModalHeaderClose = styled.button`
  opacity: 0.5;
  font-size: 14px;
  width: 14px;
  height: 14px;
  cursor: pointer;
  padding: 0;
  border: none;
  background: transparent;
  font-style: normal;
  font-weight: 400;
  font-variant: normal;
  margin-top: -20px;
  margin-right: 11px;
`

export const BtnsContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  button:first-child {
    margin-right: 16px;
  }
`

export const BackBtnWrapper = styled.div`
  margin-right: 16px;
`
export const MobileModal = styled(Modal)`
  margin: 0;
  .modal {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1050;
    width: 100%;
    height: 100%;
  }
  .modal.modal__mobile {
    display: block;
  }
  .modal-dialog .modal__mobile {
    margin: 0 !important;
  }
  .modal-open .modal {
    overflow-x: hidden;
    overflow-y: auto;
  }
  .modal__mobile-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
  }
  .modal__mobile-close {
    background-color: transparent;
    padding-right: 10px;
    color: ${colors.greyTextWhiteBg};
    opacity: 0.5;
  }
  .modal__mobile .modal__mobile-dialog {
    width: 100%;
    max-width: 100%;
    height: 100%;
    margin: 0px auto;
    margin-bottom: 1000px;
  }
  .modal-content {
    border-radius: 0px;
    height: 100%;
    margin-bottom: 500px;
    position: fixed;
    text-align: left;
    background-color: ${colors.white};
  }
  .modal__mobile .modal__mobile-dialog .modal-content {
    border-radius: 0px;
    height: 100%;
    margin-bottom: 500px;
    position: fixed;
  }
`

export const CustomModal = styled.div`
  z-index: 300;
  margin-top: 60px;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const SuccessBlock = styled.div`
  padding-top: 126.5px;
  display: flex;
  flex-direction: column;
  width: 552px;
  @media ${device.mobileMax} {
    padding-top: 33px;
    width: 288px;
  }
`

export const SuccessTitle = styled.div`
  font-weight: 600;
  font-size: 18px;
  margin-bottom: 25px;
  color: #646877;
  & img {
    margin-left: 5px;
    width: 16px;
    height: 16px;
  }
  @media ${device.mobileMax} {
    width: 180px;
    margin-bottom: 9px;
  }
`

export const SuccessText = styled.div`
  font-weight: 400;
  font-size: 14px;
  color: #646877;
`

export const SuccessButtonBlock = styled.div`
  margin-top: 56px;
  align-self: center;
  button {
    border-color: #646877;
  }
`
